import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UsefulToolsService } from '../../other/usefultools.service';

@Component({
  selector: 'app-popup-textarea',
  templateUrl: './popup-textarea.html',
  styleUrls: ['./popup-textarea.scss']
})

export class PopupTextarea {
  boxString: string;

  constructor(
    public dialogref: MatDialogRef<PopupTextarea>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private usefultoolsservice: UsefulToolsService
  ) { }

  confirm() {
    if (this.boxString === '' || this.boxString === null || this.boxString === undefined) {
      this.usefultoolsservice.notify('error', 'Text area cannot be empty');
      return;
    }

    this.dialogref.close(this.boxString);
  }
}
